
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  addDiscountOverAllPath,
  addNotificationPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import NotificationManagerOverview from "./notificationManager";
import BeigeDiscountManager from "./BeigeDiscountManager";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import http from "../services/httpService";
import toast from "react-hot-toast";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function BeigeTabs() {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = React.useState(0);
  let addPage = [
    { name: "Add Notification", path: addNotificationPath },
    { name: "Add Discount", path: addDiscountOverAllPath },
  ];
  const [addTab, setAddTab] = React.useState({});
  let history = useHistory();
  const location = useLocation();
  const myparam = location.state;
  const [showAddBtn, setShowAddBtn] = React.useState(false);
  const [loadTabs, setLoadTabs] = useState(false);
  const [tabs, setTabs] = useState([]);

  const addProspect = (event) => {
    event.preventDefault();
    if (addTab["path"]) {
      history.push(addTab["path"]);
    }
  };

  const handleChange = (event, newValue) => {
    if (addPage[newValue]["path"]) {
      setShowAddBtn(true);
    } else {
      setShowAddBtn(false);
    }
    setAddTab(addPage[newValue]);
    setValue(newValue);
  };

  let tabsList = [
    {
      name: "Notification Manager",
      child: NotificationManagerOverview,
      sub: "Add Notification",
      path: addNotificationPath,
    },
    {
      name: "Discount Manager",
      child: BeigeDiscountManager,
      sub: "Add Discount",
      path: addDiscountOverAllPath,
    },
  ];
  useEffect(() => {
    toast.loading("Please wait...");

    http
      .get("/login_permissions")
      .then((res) => {
        toast.dismiss();

        if (
          res &&
          res.data &&
          res.data.Data &&
          Array.isArray(res.data.Data) &&
          res.data.Data.length > 0
        ) {
          let current_permission = res.data.Data.filter((obj) => {
            return obj.Mainmenu === "Beige - Event Management";
          });
          if (current_permission && current_permission.length > 0) {
            let finalTabsList = tabsList.filter((object) => {
              if (
                current_permission[0]["Submenus"].indexOf(object.name) !== -1
              ) {
                return object;
              }
            });
            setTabs(finalTabsList);

            if (
              myparam &&
              myparam.tab &&
              current_permission[0]["Submenus"] &&
              current_permission[0]["Submenus"].indexOf(myparam.tab) !== -1
            ) {
              let ftabs = 0;
              finalTabsList.map((obj, inx) => {
                if (obj.name === myparam.tab) {
                  ftabs = inx;
                }
              });
              let tab = ftabs;
              setAddTab(finalTabsList[tab]);
              if (finalTabsList[tab]["path"]) {
                setShowAddBtn(true);
              }
              setValue(tab);
            } else {
              setAddTab(finalTabsList[0]);
              if (finalTabsList[0]["path"]) {
                setShowAddBtn(true);
              } else {
                setShowAddBtn(false);
              }
              setValue(0);
            }
            setLoadTabs(true);
          }
        }
      })
    // .catch((error) => { });
  }, []);
  return (
    <div className={(classes.root, "pb30")}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {tabs.map((text, index) => (
            <Tab
              label={text.name}
              key={index}
              {...a11yProps(index)}
              style={{ borderRadius: 20 }}
            />
          ))}
          {showAddBtn ? (
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 10, borderRadius: 60 }}
              startIcon={<AddCircleOutlineIcon />}
              onClick={addProspect}
              className="addBtn"
            >
              {addTab["name"]}
            </Button>
          ) : (
            ""
          )}
        </Tabs>
      </AppBar>
      {tabs.map((object, index) => {
        return (
          <TabPanel value={value} index={index} key={"tab" + index}>
            {React.createElement(object.child)}
          </TabPanel>
        );
      })}
    </div>
  );
}
export default BeigeTabs;
